import DeleteIcon from "@mui/icons-material/Delete";
import {
  Box,
  Button,
  Card,
  CardContent,
  Checkbox,
  FormControlLabel,
  IconButton,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Typography,
} from "@mui/material";
import { message, Tag } from "antd";
import moment from "moment";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { useDataLayerValue } from "../../DataLayer/DataLayer";
import { getMobilePage } from "../../utils/ApiCalls/AddMobilePage";
import {
  bulkShipMobilePage,
  bulkValShipMobilePage,
  createShipMobilePage,
  deleteShipMobilePage,
  getShipMobilePage,
} from "../../utils/ApiCalls/AddShipMobilePage";
import { addlog, addBulkLogs } from "../../utils/ApiCalls/Logs";
import { getCategoryOption } from "../../utils/ApiCalls/Mobile/ActivityMasters";
import { CRUISE_PAGE_LOG_TYPES } from "../../constants/logging";
import {
  getSailingPageData,
  updateSailingPageData,
} from "../../utils/ApiCalls/SailingData";
import { checkFields } from "../../utils/Validation/checkFields";
import SwitchBar from "../Pages/SwitchBar";
import SearchBar from "../SearchField/SearchBar";
import CustomizedData from "../UI/CustomizedData";

const CruisePageSelector = ({
  vessel_id,
  sailing_date,
  vesselOptions,
  sailing_id,
  sailing_page,
}) => {
  const { vessel } = useParams();

  const formatCruiseTitle = (sailingDate, duration = 7) => {
    const startDate = moment(sailingDate);
    const endDate = startDate.clone().add(duration, 'days');
    return `${startDate.format("DD MMM")} to ${endDate.format("DD MMM YYYY")} / ${duration} Nights`;
  };

  const [availablePagesList, setAvailablePagesList] = useState([]);
  const [availablePagesList3, setAvailablePagesList3] = useState([]);
  const [mode, setMode] = useState("new");
  const navigate = useNavigate();
  const [activeCat, setActiveCat] = useState("all");
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [newPagesSelected, setNewPagesSelected] = useState([]);
  const [newDuplicatePageSelected, setNewDuplicatePagesSelected] = useState([]);

  const [copySailingDate, setCopySailingDates] = useState();
  const [search, setSearch] = useState("");
  const [count, setCount] = useState(0);
  const [activeCat2, setActiveCat2] = useState("all");
  const [page2, setPage2] = useState(1);
  const [pageSize2, setPageSize2] = useState(10);
  const [search2, setSearch2] = useState("");
  const [count2, setCount2] = useState(0);
  const [activeCat3, setActiveCat3] = useState("all");
  const [page3, setPage3] = useState(1);
  const [pageSize3, setPageSize3] = useState(10);
  const [search3, setSearch3] = useState("");
  const [selectMultiple, setSelectMultiple] = useState(false);
  const [copysailingDates, setCopySailingDate] = useState();
  const [count3, setCount3] = useState(0);
  const [categoriesOption, setactivitycategoryOption] = useState([]);
  const [{ userDetails }, dispatch] = useDataLayerValue();
  const [assignedPages, setAssignedPages] = useState([]);
  const handleAssign = async (page) => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });
    let dataValues = {
      sailing_date: sailing_date,
      package_id: sailing_page?.package_id,
      catergory_id: page?.catergory_id || page?.catergory_id,
      shore_page_id: page?.shorePage?.id || page.id,
      ship_data: page?.ship_data || {},
      vessel_id: vessel_id,
      is_active: 1,
    };
    let newValues = [dataValues];
    dataValues = newValues[0];

    let valid = checkFields(dataValues);

    if (valid) {
      dispatch({
        type: "SET_ERROR_MESSAGE",
        errMess: { message: valid, type: "error" },
      });
      dispatch({
        type: "SET_LOADING",
        loading: false,
      });
    } else {
      const values = {
        ...dataValues,
      };

      let data;
      data = await createShipMobilePage(values);

      if (data?.error) {
        dispatch({
          type: "SET_ERROR_MESSAGE",
          errMess: { message: data.error, type: "error" },
        });
        dispatch({
          type: "SET_LOADING",
          loading: false,
        });
        return;
      } else {
        const pageTitle = page?.title || page?.venue?.name || page?.shorePage?.title || page?.shorePage?.venue?.name || "Unknown Page";
        const cruiseTitle = formatCruiseTitle(sailing_date, sailing_page?.duration || 7);
        
        await addlog(
          mode === "duplicate" ? CRUISE_PAGE_LOG_TYPES.ACTIONS.PAGE_DUPLICATED : CRUISE_PAGE_LOG_TYPES.ACTIONS.PAGE_ASSIGNED,
          CRUISE_PAGE_LOG_TYPES.MODULE,
          {
            title: `${pageTitle} - ${cruiseTitle} Cruise`,
            page_name: pageTitle,
            sailing_date: moment(sailing_date).format("YYYY-MM-DD")
          },
          userDetails?.id
        );
        
        const successMessage = mode === "duplicate" ? "Page duplicated successfully" : "Page assigned successfully";
        dispatch({
          type: "SET_ERROR_MESSAGE",
          errMess: { message: successMessage, type: "success" },
        });
        
        dispatch({
          type: "SET_LOADING",
          loading: false,
        });
        getDataBySailing();
        if (mode == "duplicate") getData2(page3);
        else getData(page);
      }
    }
  };

  useEffect(() => {
    getOptionLocation();
  }, [vessel_id]);

  const getOptionLocation = async () => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });

    let activity = await getCategoryOption({
      vessel_id: vessel_id,
      limit: 1000,
    });
    let sailing = await getSailingPageData({
      vessel_id: vessel_id,
      limit: 1000,
    });
    if (activity.error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: activity.error,
      });
    } else {
      setactivitycategoryOption(activity?.data);
      setCopySailingDate(sailing?.data);
    }
    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
  };
  const handleRemove = async (id) => {
    // Find the page being removed to get its details
    const pageToRemove = assignedPages.find(p => p.id === id);
    const pageTitle = pageToRemove?.shorePage?.title || pageToRemove?.shorePage?.venue?.name || "Unknown Page";
    
    await deleteShipMobilePage(id);
    
    const cruiseTitle = formatCruiseTitle(sailing_date, sailing_page?.duration || 7);
    
    await addlog(
      CRUISE_PAGE_LOG_TYPES.ACTIONS.PAGE_REMOVED,
      CRUISE_PAGE_LOG_TYPES.MODULE,
      {
        title: `${pageTitle} - ${cruiseTitle} Cruise`,
        page_name: pageTitle,
        sailing_date: moment(sailing_date).format("YYYY-MM-DD")
      },
      userDetails.id
    );
    
    dispatch({
      type: "SET_ERROR_MESSAGE",
      errMess: { message: "Page removed successfully", type: "success" },
    });
    
    await getDataBySailing(page2);
    if (mode == "duplicate") await getData2(page3);
    else await getData(page);
  };

  useEffect(() => {
    getData();
  }, [page, pageSize, search, activeCat]);

  useEffect(() => {
    getDataBySailing();
  }, [page2, pageSize2, search2, activeCat2]);

  const getData = async () => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });
    let dataQuery = {
      vessel_id: vessel_id,
      search: search,
      page: page,
      limit: pageSize,
      package_id: sailing_page?.package_id,
      is_active: 1,
    };
    if (activeCat !== "all") {
      dataQuery.catergory_id = activeCat;
    }
    let data = await getMobilePage(dataQuery);
    setAvailablePagesList(data.data || []);
    setCount(data?.count);

    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
  };
  useEffect(() => {
    if (copySailingDate && copySailingDate !== "") getData2();
  }, [page3, pageSize3, search3, activeCat3, copySailingDate]);
  const getData2 = async () => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });
    let dataQuery = {
      vessel_id: vessel_id,
      package_id: copySailingDate,
      old_package_id: sailing_page?.package_id,
      search: search3,
      page: page3,
      limit: pageSize3,
    };
    if (activeCat3 !== "all") {
      dataQuery.catergory_id = activeCat3;
    }
    let data = await getShipMobilePage(dataQuery);
    setAvailablePagesList3(data.data);
    setCount3(data?.count);

    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
  };
  const selectAll = () => {
    if (mode == "duplicate") {
      setNewDuplicatePagesSelected(availablePagesList3.map((item) => item.id));
    } else {
      setNewPagesSelected(availablePagesList.map((item) => item.id));
    }
    setSelectMultiple(true);
  };
  const deselectAll = () => {
    if (mode == "duplicate") {
      setNewDuplicatePagesSelected([]);
    } else {
      setNewPagesSelected([]);
    }
    setSelectMultiple(false);
  };

  const handlePaginationAfterDelete = (currentPage, setPageFunc, totalCount, pageSize, availableList, selectedCount) => {
    const totalPages = Math.ceil(totalCount / pageSize);
    if (currentPage > 1 && currentPage >= totalPages && availableList.length === selectedCount) {
      setPageFunc(currentPage - 1);
    } else {
      return currentPage;
    }
  };
  const getDataBySailing = async () => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });
    let dataQuery = {
      package_id: sailing_page?.package_id,
      search: search2,
      page: page2,
      vessel_id: vessel_id,
      limit: pageSize2,
    };
    if (activeCat2 !== "all") {
      dataQuery.catergory_id = activeCat2;
    }
    let data = await getShipMobilePage(dataQuery);
    setAssignedPages((data.data || []).filter((item) => item?.shorePage?.is_active));

    setCount2(data?.count);

    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
  };

  const applyPages = async () => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });
    if (mode == "duplicate") {
      const selectedPages = availablePagesList3.filter(page => 
        newDuplicatePageSelected.includes(page.id)
      );
      
      let val = await bulkShipMobilePage({
        page_ids: newDuplicatePageSelected,
        vessel_id: vessel_id,
        sailing_date,
        package_id: sailing_page?.package_id,
      });
      
      if (val.error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: val.error,
        });
      } else {
        const cruiseTitle = formatCruiseTitle(sailing_date, sailing_page?.duration || 7);
        
        const bulkLogs = selectedPages.map(page => {
          const pageName = page?.title || page?.venue?.name || page?.shorePage?.title || page?.shorePage?.venue?.name || 'Unknown Page';
          
          return {
            actions: CRUISE_PAGE_LOG_TYPES.ACTIONS.PAGE_DUPLICATED,
            type: CRUISE_PAGE_LOG_TYPES.MODULE,
            data: {
              title: `${pageName} - ${cruiseTitle} Cruise`,
              page_name: pageName,
              sailing_date: moment(sailing_date).format("YYYY-MM-DD")
            },
            user_id: userDetails?.id
          };
        });
        
        await addBulkLogs(bulkLogs);
        
        dispatch({
          type: "SET_ERROR_MESSAGE",
          errMess: { message: `${selectedPages.length} pages duplicated successfully`, type: "success" },
        });
        
        getDataBySailing();
        if (mode == "duplicate") {
          const resultPage = handlePaginationAfterDelete(page3, setPage3, count3, pageSize3, availablePagesList3, selectedPages.length);
          if (resultPage) getData2(resultPage);
        } else {
          const resultPage = handlePaginationAfterDelete(page, setPage, count, pageSize, availablePagesList, selectedPages.length);
          if (resultPage) getData(resultPage);
        }
        clearData();
      }
    } else {
      const selectedPages = availablePagesList.filter(page => 
        newPagesSelected.includes(page.id)
      );
      
      let val = await bulkValShipMobilePage({
        page_ids: newPagesSelected,
        vessel_id: vessel_id,
        sailing_date,
        package_id: sailing_page?.package_id,
      });
      
      if (val.error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: val.error,
        });
      } else {
        const cruiseTitle = formatCruiseTitle(sailing_date, sailing_page?.duration || 7);
        
        const bulkLogs = selectedPages.map(page => {
          const pageName = page?.title || page?.venue?.name || page?.shorePage?.title || page?.shorePage?.venue?.name || 'Unknown Page';
          
          return {
            actions: CRUISE_PAGE_LOG_TYPES.ACTIONS.PAGE_ASSIGNED,
            type: CRUISE_PAGE_LOG_TYPES.MODULE,
            data: {
              title: `${pageName} - ${cruiseTitle} Cruise`,
              page_name: pageName,
              sailing_date: moment(sailing_date).format("YYYY-MM-DD")
            },
            user_id: userDetails?.id
          };
        });
        
        await addBulkLogs(bulkLogs);
        
        dispatch({
          type: "SET_ERROR_MESSAGE",
          errMess: { message: `${selectedPages.length} pages assigned successfully`, type: "success" },
        });
        
        getDataBySailing();
        if (mode == "duplicate") {
          const resultPage = handlePaginationAfterDelete(page3, setPage3, count3, pageSize3, availablePagesList3, selectedPages.length);
          if (resultPage) getData2(resultPage);
        } else {
          const resultPage = handlePaginationAfterDelete(page, setPage, count, pageSize, availablePagesList, selectedPages.length);
          if (resultPage) getData(resultPage);
        }
        clearData();
      }
    }
    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
  };
  const clearData = () => {
    setNewDuplicatePagesSelected([]);
    setNewPagesSelected([]);
    setSelectMultiple(false);
  };


  return (
    <Box>
      <Box p={2}>
        <RadioGroup value={mode} onChange={(e) => setMode(e.target.value)}>
          <FormControlLabel
            value="new"
            control={<Radio />}
            label="Create New Page"
          />
          <FormControlLabel
            value="duplicate"
            control={<Radio />}
            label="Duplicate Previous Pages"
          />
        </RadioGroup>
      </Box>
      {/* <Box
        display="flex"
        sx={{ justifyContent: "flex-end", paddingRight: 2, gap: "10px" }}
      >
        <Button onClick={draftSailing} variant="contained">
          Save As Draft
        </Button>
        <Button onClick={publishSailing} variant="outlined">
          Publish
        </Button>
      </Box> */}
      <Box display="flex" gap={4} p={2}>
        {mode == "duplicate" && (
          <Box sx={{ border: "1px solid lightgray" }} p={2} flex={1}>
            <Typography variant="title" fontWeight="bold">
              Available Cruise Pages
            </Typography>
            <Typography variant="body2" color="text.secondary" mb={2}>
              Select pages to assign to this sailing{" "}
            </Typography>

            <Select
              fullWidth
              value={copySailingDate}
              onChange={(e) => setCopySailingDates(e.target.value)}
              size="small"
              defaultValue=""
              sx={{ mb: 2 }}
            >
              <MenuItem value="">NA</MenuItem>
              {copysailingDates?.map((item) => {
                if (item.sailing_date?.split("T")[0] === sailing_date.split("T")[0]) {
                  return null;
                }
                
                return (
                  <MenuItem key={item.id} value={item.package_id}>
                    {formatCruiseTitle(item.sailing_date, item?.duration || 7)}
                  </MenuItem>
                );
              })}
            </Select>

            <SearchBar
              value={search3}
              SearchValue={() => {
                setPage3(1);
              }}
              setValue={(e) => {
                setSearch3(e.target.value);
              }}
            />
            <Select
              fullWidth
              size="small"
              value={activeCat3}
              onChange={(e) => setActiveCat3(e.target.value)}
              defaultValue="all"
              sx={{ mb: 2 }}
            >
              <MenuItem value="all">All Categories</MenuItem>
              {categoriesOption?.map((item) => {
                return (
                  <MenuItem key={item.id} value={item.id}>
                    {item.name}
                  </MenuItem>
                );
              })}
            </Select>
            <Box
              sx={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}
            >
              {!selectMultiple && (
                <Button size="small" onClick={selectAll} variant="outlined">
                  Select All
                </Button>
              )}
              {selectMultiple && (
                <Button size="small" onClick={deselectAll} variant="outlined">
                  Deselect All
                </Button>
              )}
              {selectMultiple && (
                <Button onClick={applyPages} size="small" variant="contained">
                  Apply
                </Button>
              )}{" "}
            </Box>
            <CustomizedData
              setRows={setAvailablePagesList3}
              setPageSize={setPageSize3}
              setPage={setPage3}
              pageSize={pageSize3}
              page={page3}
              count={count3}
              columns={[]}
              rows={availablePagesList3}
              sortHandler={() => { }}
              render={(page, index) => (
                <Card
                  key={index}
                  variant="outlined"
                  sx={{
                    mb: 2,
                    border: "1px solid black",
                    cursor: "pointer",
                    "&:hover": { bgcolor: "grey.100" },
                  }}
                  onClick={() => handleAssign(page)}
                >
                  <CardContent
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      p: 1,
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={newDuplicatePageSelected.includes(
                              page?.id
                            )}
                            onChange={(e) =>
                              e.target.checked
                                ? setNewDuplicatePagesSelected((item) => [
                                  ...item,
                                  page.id,
                                ])
                                : setNewDuplicatePagesSelected((item) => [
                                  ...item.filter((val) => val !== page.id),
                                ])
                            }
                          />
                        }
                      />
                      <Box>
                        <Typography>
                          {page?.shorePage?.title ||
                            page?.shorePage?.venue?.name}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          {page.category}
                        </Typography>
                        <Tag color={"red"}>
                          {
                            categoriesOption?.find(
                              (item) => item.id == page?.shorePage?.catergory_id
                            )?.name
                          }
                        </Tag>{" "}
                        <Tag>{page?.shorePage?.child_category?.name}</Tag>
                      </Box>
                    </Box>
                  </CardContent>
                </Card>
              )}
              title={"Cabin Bookings"}
            />
          </Box>
        )}
        {mode == "new" && (
          <Box sx={{ border: "1px solid lightgray" }} p={2} flex={1}>
            <Typography variant="title" fontWeight="bold">
              Available Cruise Pages
            </Typography>
            <Typography variant="body2" color="text.secondary" mb={2}>
              Select pages to assign to this sailing{" "}
            </Typography>

            {mode == "duplicate" && (
              <Select fullWidth size="small" defaultValue="jan" sx={{ mb: 2 }}>
                <MenuItem value="jan">Jan 24 - Jan 31, 2024</MenuItem>
              </Select>
            )}

            <SearchBar
              value={search}
              SearchValue={() => {
                setPage(1);
              }}
              setValue={(e) => {
                setSearch(e.target.value);
              }}
            />
            <Select
              fullWidth
              size="small"
              value={activeCat}
              onChange={(e) => setActiveCat(e.target.value)}
              defaultValue="all"
              sx={{ mb: 2 }}
            >
              <MenuItem value="all">All Categories</MenuItem>
              {categoriesOption?.map((item) => {
                return (
                  <MenuItem key={item.id} value={item.id}>
                    {item.name}
                  </MenuItem>
                );
              })}
            </Select>
            <Box
              sx={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}
            >
              {!selectMultiple && (
                <Button size="small" onClick={selectAll} variant="outlined">
                  Select All
                </Button>
              )}
              {selectMultiple && (
                <Button size="small" onClick={deselectAll} variant="outlined">
                  Deselect All
                </Button>
              )}
              {selectMultiple && (
                <Button onClick={applyPages} size="small" variant="contained">
                  Apply
                </Button>
              )}{" "}
            </Box>
            <CustomizedData
              setRows={setAvailablePagesList}
              setPageSize={setPageSize}
              setPage={setPage}
              pageSize={pageSize}
              page={page}
              count={count}
              columns={[]}
              rows={availablePagesList}
              sortHandler={() => { }}
              render={(page, index) => (
                <Card
                  key={index}
                  variant="outlined"
                  sx={{
                    mb: 2,
                    border: "1px solid black",
                    cursor: "pointer",
                    "&:hover": { bgcolor: "grey.100" },
                  }}
                  onClick={() => handleAssign(page)}
                >
                  <CardContent
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      p: 1,
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={newPagesSelected.includes(page?.id)}
                            onChange={(e) =>
                              e.target.checked
                                ? setNewPagesSelected((item) => [
                                  ...item,
                                  page.id,
                                ])
                                : setNewPagesSelected((item) => [
                                  ...item.filter((val) => val !== page.id),
                                ])
                            }
                          />
                        }
                      />
                      <Box>
                        <Typography>
                          {page?.title || page?.venue?.name}
                        </Typography>
                        <Tag color={"red"}>
                          {
                            categoriesOption?.find(
                              (item) => item.id == page.catergory_id
                            )?.name
                          }
                        </Tag>{" "}
                        <Tag>{page.child_category?.name}</Tag>
                      </Box>
                    </Box>
                  </CardContent>
                </Card>
              )}
              title={"Cabin Bookings"}
            />
          </Box>
        )}

        {/* Right Side */}
        <Box sx={{ border: "1px solid lightgray" }} p={2} flex={1}>
          <Typography variant="subtitle1" fontWeight="bold">
            Pages Assigned to this sailing{" "}
            {formatCruiseTitle(sailing_date, sailing_page?.duration || 7)}
            {/* {moment(sailing_date).format("DD-MMMM-YYYY")} */}
          </Typography>
          <Typography variant="body2" color="text.secondary" mb={2}>
            {count2} Pages selected
          </Typography>
          <SearchBar
            value={search2}
            SearchValue={() => {
              setPage2(1);
            }}
            setValue={(e) => {
              setSearch2(e.target.value);
            }}
          />

          <SwitchBar
            tabs={
              [
                ...categoriesOption?.map((item) => ({
                  title: item.name,
                  value: item.id,
                })),
              ] || []
            }
            activeTab={activeCat2}
            setActiveTab={setActiveCat2}
            allowToggleOff={true}
          />
          <CustomizedData
            setRows={setAssignedPages}
            setPageSize={setPageSize2}
            setPage={setPage2}
            pageSize={pageSize2}
            page={page2}
            count={count2}
            columns={[]}
            rows={assignedPages}
            sortHandler={() => { }}
            render={(page, index) => (
              <Card
                key={page.id}
                variant="outlined"
                sx={{ mb: 2, border: "1px solid black" }}
              >
                <CardContent
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    p: 1,
                  }}
                >
                  <Box>
                    <Typography>
                      {page?.shorePage?.title || page?.shorePage?.venue?.name}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      {page.category}
                    </Typography>
                    <Tag color={"red"}>
                      {
                        categoriesOption?.find(
                          (item) => item.id == page?.shorePage?.catergory_id
                        )?.name
                      }
                    </Tag>{" "}
                    <Tag>{page?.shorePage?.child_category?.name}</Tag>
                  </Box>
                  <Box display="flex" gap={1}>
                    <Button
                      size="small"
                      onClick={() => {
                        localStorage.setItem("sailing-date", sailing_date);
                        localStorage.setItem(
                          "sailing-page",
                          JSON.stringify(sailing_page)
                        );
                        localStorage.setItem(
                          "old-url",
                          window.location.pathname
                        );
                        navigate(
                          "/ship/all-pages/" +
                          vesselOptions
                            .find((item) => item.id == vessel_id)
                            ?.name?.replaceAll(" ", "-")
                            ?.toLowerCase() +
                          "/" +
                          +page?.shorePage?.catergory_id +
                          "/edit/" +
                          page.id
                        );
                      }}
                      variant="outlined"
                    >
                      Edit Content
                    </Button>
                    <IconButton
                      size="small"
                      color="error"
                      onClick={() => handleRemove(page.id)}
                    >
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </Box>
                </CardContent>

              </Card>
            )}
            title={"Cabin Bookings"}
          />
        </Box>
      </Box>
      <Box sx={{ width: "100%", display: "flex", justifyContent: "flex-end", p: 1 }}>
        <Button
          type="link"
          href={`/shore/cruise-page/${vessel}`}
          variant="contained"
          className="btn main_submit"
        > 
          Save
        </Button>
      </Box>
    </Box>
  );
};

export default CruisePageSelector;
